import Tabs from '../../../js/src/__page/tabs';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        Tabs.init();
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
